module.exports = __webpack_public_path__ + "img/BFB5A4_DEDCCB_D7D4CC_DCD3C2-256px.a23bf08f.png";